import { Trans, useTranslation } from '@repo/translations/use-translation';
import { useState } from 'react';

import { useCartContext } from '@zooplus/cart-provider';

import { useMembershipOffer } from '../../../../hooks/useMembershipOffer';
import { PremiumAddedModal } from '../../../UI/PremiumAddedModal/PremiumAddedModal';
import { ProgramLogo } from '../../../UI/ProgramLogo/ProgramLogo';
import { BannerButtons } from '../BannerButtons/BannerButtons';

import styles from './BannerContent.module.css';

interface BannerContentProps {
  isCustomerLoggedIn: boolean;
  isBasicCustomer: boolean;
  endDate: string;
}

export const BannerContent = ({
  isCustomerLoggedIn,
  isBasicCustomer,
  endDate,
}: BannerContentProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: membership } = useMembershipOffer(isCustomerLoggedIn);
  const { cart } = useCartContext();
  const { t } = useTranslation();

  const isCartEmpty = cart?.articles?.length === 0;

  return (
    <div className={styles.bannerContent}>
      <div className={styles.heading}>
        <ProgramLogo height={30} />
        <h1 data-testid="banner-title" className={styles.title}>
          {!isCustomerLoggedIn
            ? t('loyalty-program.public-landing-page.banner.title.not-logged')
            : isBasicCustomer
              ? t('loyalty-program.public-landing-page.banner.title.basic')
              : t('loyalty-program.public-landing-page.banner.title.premium')}
        </h1>
        <p data-testid="banner-subtitle" className={styles.subtitle}>
          {!isCustomerLoggedIn ? (
            t('loyalty-program.public-landing-page.banner.subtitle.not-logged')
          ) : isBasicCustomer ? (
            t('loyalty-program.public-landing-page.banner.subtitle.basic')
          ) : (
            <Trans
              i18nKey={t('loyalty-program.public-landing-page.banner.subtitle.premium')}
              values={{
                endDate: endDate,
              }}
            />
          )}
        </p>
      </div>
      <BannerButtons
        isCustomerLoggedIn={isCustomerLoggedIn}
        isBasicCustomer={isBasicCustomer}
        hasOfferAvailable={membership !== undefined}
        articleId={membership?.offer.articleId}
        setIsModalOpen={setIsModalOpen}
      />
      <PremiumAddedModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        isCartEmpty={isCartEmpty}
      />
    </div>
  );
};
